/**
 * Given an object, expand it full in the console.log.  This will recursively call itself and print out
 * all nodes of the json object.
 *
 * Really just a convenience function to not have to expand the object in the console with the mouse everytime.
 *
 * @param {*} debug
 * @return {*}
 */
export function consoleDebugExpandedObject(debug) {
  _consoleDebugExpandedObjectHelper(debug, 0);
}

/**
 * Helper for consoleDebugExpandedObject to expose the tabCount internal recursive call, that external caller does not
 * need to know about.
 *
 * @param {*} debug
 * @param {Number} tabCount   Keeps track of the tabCount as we are going through nested objects.
 * @return {*}
 * @private
 */
export function _consoleDebugExpandedObjectHelper(debug, tabCount) {
  let tabSpacer = "";
  for (let i = 0; i < tabCount; i++) {
    tabSpacer += "  ";
  }

  if (Array.isArray(debug)) {
    return debug.join(", ");
  } else if (debug == null) {
    return "nullOrUndefined";
  } else if (typeof debug === 'object') {
    Object.keys(debug).forEach(objKey => {
      let nextItem = debug[objKey];
      if (typeof nextItem === 'object' && nextItem != null) {
        console.log(`${tabSpacer}${objKey}`);
        _consoleDebugExpandedObjectHelper(nextItem, tabCount + 1);
      } else {
        console.log(`${tabSpacer}${objKey} : %s`, _consoleDebugExpandedObjectHelper(nextItem));
      }
    });
    return ;
  }

  return debug;
}
